import "./common-css/index.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from "react-router-dom";
import router from "./pages/Router";
import Notification from "./components/Notification";
import { store } from './store/store'
import { Provider } from 'react-redux'
import ThemeProvider from './theme/ThemeProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <Root />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

function Root() {
  return (
    <>
      <RouterProvider router={router} />
      <Notification />
    </>
  )
}
